import classNames from 'classnames'
import { t } from 'i18next'
import { useContext } from 'react'
import childPlanFormDataContext from '../../../contexts/ChildPlanFormDataContext'
import ParentFormDataContext from '../../../contexts/ParentFormDataContext'
import RoutesFormDataContext from '../../../contexts/RoutesFormDataContext'
import { IFormDataInput } from '../../../model/IFormDataInput'
import { handleDDLBlur } from '../../../utils/ddlBlur'
import { handleDDLFocus } from '../../../utils/ddlFocus'
import { setRouteParam } from '../../../utils/routeHelper'
import DropDownList, { ddlListItem } from '../../dropDownList/DropDownList'
import InputBox from '../../inputBox/InputBox'
import DoNotOfferErrorMsg from '../doNotOfferErrorMsg/DoNotOfferErrorMsg'

export interface IParentGuardian {
    className?: string
    forwardedRef: React.RefObject<HTMLDivElement>
}

const ParentGuardian: React.FC<IParentGuardian> = ({
    className,
    forwardedRef,
}) => {
    const { parentFormData, setParentFormData } = useContext(
        ParentFormDataContext
    )
    const { routesFormData, setRoutesFormData } = useContext(RoutesFormDataContext)
    const { childPlanFormData, setChildPlanFormData } = useContext(
        childPlanFormDataContext
    )

    const handleDDLChange = (name: string, value: ddlListItem) => {
        if (value?.id && parentFormData?.Province?.id !== value?.id) {
            // setParentFormData({ ...parentFormData, [name]: value })
            if (name === 'Province') {
                const dataInput = parentFormData.CommonChildPlanFormInputData
                if (dataInput != null) {
                    setParentFormData((prevFormData) => {
                        let newFormData = { ...prevFormData }
                        let updatedDataInput = { ...dataInput }
                        if (dataInput.IsBlur) {
                            updatedDataInput = {
                                ...dataInput,
                                IsBlur: true,
                                IsFocus: false,
                                IsValid: false,
                                ErrorMessage: 'Required',
                            }
                        }

                        newFormData = {
                            ...prevFormData,
                            [name]: value,
                            ['SchoolBoard']: { name: '', id: -1 },
                            CommonChildPlanFormInputData: updatedDataInput,
                        }
                        setRouteParam(newFormData?.Province?.id, newFormData?.Language)
                        return newFormData
                    }
                    )


                }

                childPlanFormData.map((child, index) => {
                    const schoolInput = child.ChildPlanFormDataInput.find(
                        (x) => x.Name === 'School'
                    )
                    if (schoolInput != null) {
                        let updatedSchoolInput = { ...schoolInput }

                        if (schoolInput.IsBlur) {
                            updatedSchoolInput = {
                                ...schoolInput,
                                ListItems: [],
                                IsBlur: true,
                                IsFocus: false,
                                IsValid: false,
                                ErrorMessage: 'Required',
                            }
                        }

                        const updatedFormInputs = [...child.ChildPlanFormDataInput]
                        const schoolIndex = updatedFormInputs.indexOf(schoolInput)
                        updatedFormInputs[schoolIndex] = updatedSchoolInput
                        setChildPlanFormData((prevFormData) => {
                            const newFormData = [...prevFormData]
                            newFormData[index] = {
                                ...child,
                                ['School']: { name: '', id: -1 },
                                ChildPlanFormDataInput: updatedFormInputs,
                            }
                            return newFormData
                        })
                    }
                })
            }
        }
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target

        let isValid: boolean = false
        let errorMessage: string = ''

        const dataInput = parentFormData.ParentFormDataInput.find(
            (x) => x.Name === name
        )

        if (dataInput != null) {
            // Validation - required
            if (dataInput.Required && !value) {
                isValid = false

                const temp = dataInput.ErrorMessageList.find(
                    (x) => x.type === 'required'
                )

                if (temp != null) {
                    errorMessage = temp.error
                }
            } else {
                isValid = true
            }

            // Validation - pattern match
            if (isValid) {
                const regex = RegExp(dataInput.Pattern)

                if (dataInput.Pattern !== '' && !regex.test(value)) {
                    isValid = false
                    const temp = dataInput.ErrorMessageList.find(
                        (x) => x.type === 'pattern'
                    )

                    if (temp != null) {
                        errorMessage = temp.error
                    }
                } else {
                    isValid = true
                }
            }

            const updatedTemp = {
                ...dataInput,
                IsBlur: true,
                IsFocus: false,
                IsValid: isValid,
                ErrorMessage: errorMessage,
            }
            const updatedFormInputs = [...parentFormData.ParentFormDataInput]
            const index = updatedFormInputs.indexOf(dataInput)
            updatedFormInputs[index] = updatedTemp
            setParentFormData((prevState) => ({
                ...prevState,
                [name]: value,
                ParentFormDataInput: updatedFormInputs,
            }))
        }
    }

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        const { name, value } = e.target
        let isValid: boolean = false
        let errorMessage: string = ''

        const dataInput = parentFormData.ParentFormDataInput.find(
            (x) => x.Name === name
        )

        if (dataInput != null) {
            // Validation - required
            if (dataInput.Required && !value) {
                isValid = false

                const temp = dataInput.ErrorMessageList.find(
                    (x) => x.type === 'required'
                )

                if (temp != null) {
                    errorMessage = temp.error
                }
            } else {
                isValid = true
            }

            // Validation - pattern match
            if (isValid) {
                const regex = RegExp(dataInput.Pattern)

                if (dataInput.Pattern !== '' && !regex.test(value)) {
                    isValid = false
                    const temp = dataInput.ErrorMessageList.find(
                        (x) => x.type === 'pattern'
                    )

                    if (temp != null) {
                        errorMessage = temp.error
                    }
                } else {
                    isValid = true
                }
            }

            const updatedTemp = {
                ...dataInput,
                IsBlur: true,
                IsFocus: false,
                IsValid: isValid,
                ErrorMessage: errorMessage,
            }
            const updatedFormInputs = [...parentFormData.ParentFormDataInput]
            const index = updatedFormInputs.indexOf(dataInput)
            updatedFormInputs[index] = updatedTemp
            setParentFormData((prevState) => ({
                ...prevState,
                ParentFormDataInput: updatedFormInputs,
            }))
        }
    }

    const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
        const { name, value } = e.target
        const temp = parentFormData.ParentFormDataInput.find(
            (x) => x.Name === name
        )

        if (temp != null) {
            const updatedTemp = { ...temp, IsBlur: false, IsFocus: true }
            const updatedFormInputs = [...parentFormData.ParentFormDataInput]
            const index = updatedFormInputs.indexOf(temp)
            updatedFormInputs[index] = updatedTemp
            setParentFormData((prevState) => ({
                ...prevState,
                ParentFormDataInput: updatedFormInputs,
            }))
        }
    }
    routesFormData.location = parentFormData.Province.id

    return (
        <div
            ref={forwardedRef}
            className={classNames(className, "flex justify-center")}
        >
            <div className='bg-white lg:w-[55rem] md:w-[31rem] w-[20rem] shadow-md py-6 flex justify-center'>
                <div className='lg:w-[42rem] w-[18rem] relative'>
                    <h1 className="text-lg font-bold text-center pb-5">
                        {t('parentAndGuardianInfo')}
                    </h1>

                    <div className={classNames('flex items-center', 'lg:grid lg:grid-cols-2 lg:space-x-2 flex-col')}>
                        {parentFormData.ParentFormDataInput.map(
                            (input: IFormDataInput, index) => {
                                if (input.ControlType === 'InputBox') {
                                    return (
                                        <InputBox
                                            key={input.Id}
                                            type={input.Type}
                                            inputID={input.Id}
                                            label={t(input.Label) || ''}
                                            width={input.Width}
                                            height={input.Height}
                                            minWidth={input.MinWidth}
                                            className={input.ClassName}
                                            shadow={input.Shadow}
                                            onChange={(
                                                e: React.ChangeEvent<HTMLInputElement>
                                            ) => handleChange(e)}
                                            onBlur={(
                                                e: React.FocusEvent<HTMLInputElement>
                                            ) => handleBlur(e)}
                                            onFocus={(
                                                e: React.FocusEvent<HTMLInputElement>
                                            ) => handleFocus(e)}
                                            value={parentFormData[input.Name]}
                                            name={input.Name}
                                            required={input.Required}
                                            error={t(input.ErrorMessage) || ''}
                                            isValid={input.IsValid}
                                            isBlur={input.IsBlur}
                                            isFocus={input.IsFocus}
                                        />
                                    )
                                } else if (input.ControlType === 'DropDownList') {
                                    return (
                                        <div key={input.Id}>
                                            <DropDownList
                                                key={input.Id}
                                                className={input.ClassName}
                                                width={input.Width}
                                                height={input.Height}
                                                list={input.ListItems || []}
                                                label={t(input.Label) || ''}
                                                inputID={input.Id}
                                                selectedItem={
                                                    parentFormData[input.Name]
                                                }
                                                name={input.Name}
                                                required={input.Required}
                                                onChange={handleDDLChange}
                                                onBlur={(e) => handleDDLBlur(parentFormData, setParentFormData, e)}
                                                onFocus={(e) => handleDDLFocus(parentFormData, setParentFormData, e)}
                                                error={t(input.ErrorMessage) || ''}
                                                isValid={input.IsValid}
                                                isBlur={input.IsBlur}
                                                isFocus={input.IsFocus}
                                                disabled={input.Disabled}
                                            />

                                            {parentFormData.DoNotOffer && (
                                                <DoNotOfferErrorMsg
                                                    className='text-xs -mt-8 lg:ml-[0.7rem] md:ml-[0.9rem] ml-[0.8rem] lg:w-[20rem] md:w-[16rem] w-[14rem]'
                                                    province={
                                                        parentFormData?.Province?.name
                                                    }
                                                />
                                            )}
                                        </div>
                                    )
                                }
                            }
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ParentGuardian
